import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import { buildFullName } from "./queue"
import dayjs from "dayjs"

export async function getPrescriptionsOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.PRESCRIPTIONS)

  data = await Promise.all(
    data.map(async (p) => {
      let patient = p.patient

      if (!patient || typeof patient !== "object") {
        patient = await getByIdOffline(STORES.PATIENTS, p.patientId)
      }

      return {
        ...p,
        patient,
        fullName: p.fullName || buildFullName(patient),
      }
    }),
  )
  console.log("pres cription list " + JSON.stringify(data, null, 2))

  // 🔍 Filter fullName
  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((p) => p.fullName?.toLowerCase().includes(search))
  }

  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  // 📄 Pagination
  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}

export async function getAllQspOffline() {
  return await readAllData(STORES.QSP)
}

export async function getAllGnreOffline() {
  return await readAllData(STORES.GENRES)
}
